import React from 'react';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
        <p className="text-sm text-gray-500 mb-8">Effective Date: {new Date().toLocaleDateString()}</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">1. Services</h2>
        <p>CosmoComply provides a software platform to assist cosmetic companies in managing compliance with the U.S. Modernization of Cosmetics Regulation Act of 2022 (MoCRA).</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">2. No Legal Advice</h2>
        <p>CosmoComply is not a law firm or regulatory body. We provide tools to assist in compliance preparation. Final responsibility for submissions to the FDA lies with you, the customer.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">3. Accounts</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>You must provide accurate information when creating an account.</li>
          <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">4. Use of Services</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>You may not misuse the platform, attempt to hack it, or reverse engineer it.</li>
          <li>You are responsible for ensuring the accuracy of data you enter.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">5. Data</h2>
        <p>You retain ownership of your data. By using CosmoComply, you grant us the right to store and process your data for the purpose of providing services.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">6. Limitation of Liability</h2>
        <p>CosmoComply is provided “as is.” We are not liable for errors, delays, missed submissions, or regulatory penalties.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">7. Termination</h2>
        <p>We may suspend or terminate accounts that violate these terms. You may close your account at any time.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">8. Governing Law</h2>
        <p>These terms are governed by the laws of India.</p>
      </div>
    </div>
  );
};

export default TermsOfService;


